import axios, { AxiosResponse } from 'axios'
import {
  ImagemNotaVersaoUpload,
  NotasVersaoHistoricoQueryResponse,
  NotasVersaoQueryResponse,
  NotaVersaoDto,
  NotaVersaoUsuario,
  NotaVersaoView,
} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const NOTAS_VERSAO_URL = `${API_URL}/notas-versao`

// Administração (SUPER_ADMIN, NotaVersao:*)

export const getNotasVersao = (query: string): Promise<NotasVersaoQueryResponse> =>
  axios
    .get(`${NOTAS_VERSAO_URL}?${query}`)
    .then((res: AxiosResponse<NotasVersaoQueryResponse>) => res.data)

export const getNotaVersaoById = (id: number): Promise<NotaVersaoView> =>
  axios.get(`${NOTAS_VERSAO_URL}/${id}`).then((res: AxiosResponse<NotaVersaoView>) => res.data)

export const createNotaVersao = (dto: NotaVersaoDto): Promise<NotaVersaoView> =>
  axios.post(NOTAS_VERSAO_URL, dto).then((res: AxiosResponse<NotaVersaoView>) => res.data)

export const updateNotaVersao = (id: number, dto: NotaVersaoDto): Promise<NotaVersaoView> =>
  axios.put(`${NOTAS_VERSAO_URL}/${id}`, dto).then((res: AxiosResponse<NotaVersaoView>) => res.data)

export const deleteNotaVersao = (id: number): Promise<void> =>
  axios.delete(`${NOTAS_VERSAO_URL}/${id}`).then(() => undefined)

/** Envia a imagem (multipart, campo `file`) e devolve a URL absoluta de leitura para o `src` no HTML da nota. */
export const uploadImagemNotaVersao = (file: File): Promise<string> => {
  const formData = new FormData()
  formData.append('file', file)
  return axios
    .post(`${NOTAS_VERSAO_URL}/imagens`, formData)
    .then((res: AxiosResponse<ImagemNotaVersaoUpload>) => `${API_URL}${res.data.url}`)
}

// Usuário final (qualquer autenticado; o estado é sempre o do usuário logado)

/** 204 (sem nota vigente) chega com corpo vazio e vira `null`. */
export const getNotaVigente = (): Promise<NotaVersaoUsuario | null> =>
  axios
    .get(`${NOTAS_VERSAO_URL}/usuario/vigente`)
    .then((res: AxiosResponse<NotaVersaoUsuario | ''>) =>
      res.status === 204 || !res.data ? null : res.data
    )

export const getHistoricoNotasVersao = (
  query: string
): Promise<NotasVersaoHistoricoQueryResponse> =>
  axios
    .get(`${NOTAS_VERSAO_URL}/usuario?${query}`)
    .then((res: AxiosResponse<NotasVersaoHistoricoQueryResponse>) => res.data)

export const getNotaVersaoUsuario = (id: number): Promise<NotaVersaoUsuario> =>
  axios
    .get(`${NOTAS_VERSAO_URL}/usuario/${id}`)
    .then((res: AxiosResponse<NotaVersaoUsuario>) => res.data)

/** Nota excluída ou despublicada responde 404 e vira `null` (estado de tela, não erro). */
export const getNotaVersaoUsuarioDisponivel = (id: number): Promise<NotaVersaoUsuario | null> =>
  getNotaVersaoUsuario(id).catch((erro: unknown) => {
    if (axios.isAxiosError(erro) && erro.response?.status === 404) return null
    throw erro
  })

export const marcarNotaVersaoLida = (id: number): Promise<void> =>
  axios.put(`${NOTAS_VERSAO_URL}/usuario/${id}/lida`).then(() => undefined)

export const adiarNotaVersao = (id: number): Promise<void> =>
  axios.put(`${NOTAS_VERSAO_URL}/usuario/${id}/adiada`).then(() => undefined)
